import { LawInterfacesEnum } from '../enums/LawInterfacesEnum';
import { IRootState } from '../interfaces/IRootState';

export const getCoreOpenApiInfo = (state: IRootState) => state.core.openApiInfo;
export const getCoreIsLoading = (state: IRootState) => state.core.loading > 0;
export const getCoreIsDeepLoading = (state: IRootState) => state.core.isDeepLoading > 0;
export const getCoreOptionName = (state: IRootState) => state.core.optionName;
export const getCoreIsErknm = (state: IRootState) => state.core.lawInterface === LawInterfacesEnum.FZ_248;
